import { connect } from 'react-redux'
import CheckoutForm from '../CheckoutForm'

const mapStateToProps = (state) => {
  return {
    stripe: state.stripe,
    csrf: state.csrf
  }
};

export default connect(
  mapStateToProps,
)(CheckoutForm)
